export type FuelType = {
    label: string;
    value: string;
}

export const fueltypes: FuelType[] = [
    {
        label: "Petrol",
        value: "P"
    },
    {
        label: "Diesel",
        value: "D"
    },
    {
        label: "Electric",
        value: "E"
    },
    {
        label: "Hybrid",
        value: "H"
    },
    {
        label: "LPG",
        value: "L"
    },
    {
        label: "Pedal Power",
        value: ""
    },
]
